import React, { FC, ReactElement } from 'react';

import Footer from '../footer/Footer';
import Header from '../header/Header';
import InstagramEmbedLoader from '../instagram-embed-loader/InstagramEmbedLoader';
import YouTubeEmbedLoader from '../youtube-embed-loader/YouTubeEmbedLoader';
import { CookieConsentProvider } from '~/context/CookieConsentContext';
import * as cssClass from './Layout.module.scss';

import '../../styles/index.scss';

interface LayoutPageContext {
  signUp?: boolean;
}

const Layout: FC<{
  children?: ReactElement;
  pageContext?: LayoutPageContext;
}> = ({ children, pageContext }) => {
  const signUp = pageContext?.signUp !== false;

  return (
    <CookieConsentProvider>
      <div className={cssClass.layout}>
        <Header />
        <div>{children}</div>
        <Footer signUp={signUp} />
        <InstagramEmbedLoader />
        <YouTubeEmbedLoader />
      </div>
    </CookieConsentProvider>
  );
};

export default Layout;
